module.exports = "<div class=\"relative\">\r\n  <h1>404 Page Not Found</h1>\r\n</div>\r\n"